<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="520px" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">

			<el-form-item label="知识点名称:" label-width="110px">
				<el-input v-model="addForm.loreName" auto-complete="off" class="formItem" size="small"
					maxLength="200" />
			</el-form-item>

		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id: 0,
				loreName: '',
				gradeId: 0,
				courseId: 0,
			},
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		initData() {
			this.$axios.get("/basic/getlorepointinfoinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
				});
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/basic/lorepointinfosave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	}
};
</script>

<style lang="less" scoped></style>
